
import { Component, Vue } from 'vue-property-decorator';
import {ImagesImagesGetter} from "@/store/modules/images/getters";
import {Action, Getter} from "@/decorators";
import {OptionsFieldsGetter, OptionsValueGetter} from "@/store/modules/options/getters";
import {viewMode} from "@/store/modules/options/state";
import {getLocalStorageData, OptionsSetValueAction} from "@/store/modules/options/actions";

@Component
export default class Home extends Vue {
	@Getter('images/images') images!: ImagesImagesGetter
	@Getter('options/fields') optionsFields!: OptionsFieldsGetter
	@Getter('options/value') optionsValue!: OptionsValueGetter
	@Action('options/setValue') setValue!: OptionsSetValueAction

	dialog = {
		show: false,
	}
	
	upload(res: File, file: File[]) {
		file.forEach(img => {
			if (this.images.indexOf(img) === -1) this.images.push(img)
		})
	}
	
	remove(file: File) {
		const index = this.images.indexOf(file)
		if (index !== -1) {
			this.images.splice(index, 1)
		}
	}
	
	goToFullScreen() {
		this.dialog.show = true
	}
	
	createImgUrl(file: File) {
		return URL.createObjectURL(file)
	}
	
	get isImagesUploaded() {
		return this.images.length
	}
	
	get isModeSelected() {
		return this.optionsValue.length
	}
	
	get isShowViewModeButton() {
		return !(this.isImagesUploaded && this.isModeSelected)
	}
	
	get imageClasses() {
		switch (this.optionsValue) {
			case viewMode.FILL:
				return 'fill'
			case viewMode.COVER:
				return 'cover'
			case viewMode.CONTAIN:
				return 'contain'
			case viewMode.NONE:
				return 'none'
		}
	}
	
	mounted() {
		const storage = getLocalStorageData('optionValue')
		if (storage) {
			this.setValue(storage)
		}
	}
}
